import {Bank} from './device.model';

export interface ConfigResponseModel {
	titles: Title[];
	states: State[];
	genders: Gender[];
	banks: Bank[];
	allowedDisputeResponseCodes: string[];
	countries: Country[];
	cashoutFee: number;
	clickHouseSearchDays: number;
	clickHouseSearchRange: number;
	enableAgentOnboardingBvnValidation: boolean;
	enableAggregatorAgreement: boolean;
	localGovernments: LocalGovernment[];
	switchOnAgentProtectedTransfer: boolean;
	switchOnAggregatorOverdraft: boolean;
	switchOnManagerOverdraft: boolean;
	switchOnSuperAggregatorOverdraft: boolean;
	switchTransactionView: boolean;
	switchWalletView: boolean;
	agentCanRequestCard: boolean;
	aggregatorUploadLoansVerificationDocument: boolean;
	posBusinessTypeInfo: POSBusinessTypeInfo;
}

export interface POSBusinessTypeInfo {
	businessTypeId: number;
	businessTypeName: string;
	categoryId: number;
	categoryName: string;
}

export interface Gender {
	id: number;
	name: string;
	status: string;
}

export interface LocalGovernment {
	code: string;
	id: number;
	name: string;
	state?: State;
	status: string;
}

export interface Country {
	code: string;
	dialCode: string;
	id: number;
	name: string;
	status: string;
}

export interface State {
	code: string;
	country: Country;
	id: number;
	name: string;
	status: string;
}

export interface Answers {
	profileUsage: string;
	otherBusinesses: string[];
	percentageOfAgencyTransactions: number;
}

export enum SurveyAnswersEnum {
	PROFILEUSAGE = 'Profile Usage',
	OTHERBUSINESSES = 'Other Businesses',
	PERCENTAGEOFAGENCYTRANSACTIONS = 'Transaction Shared'
}

export interface Title {
	id: number;
	name: string;
	status: string;
}

export interface SystemNotification {
	createdOn: string;
	htmlContent: string;
	id: number;
	lastModifiedOn: string;
	status: string;
	responseRequired: boolean;
	responseDescription: any;
	targetAudience: string;
	title: string;
	uniqueHash: string;
}

export interface SystemNotificationModel {
	notify: boolean;
	notificationImage: string;
	systemNotification: SystemNotification;
}

export interface TimeLeftUntil{
    daysLeft: number;
    hoursLeft: number;
    minutesLeft: number;
}

export interface AggregatorRatingRequest {
	rating: number;
	comment: string;
}

export interface CountDown {
	days: number;
	hours: number;
	minutes: number;
	seconds: number;
}

export interface PndRequest {
	accountNumber: string;
	agentBusinessName: string;
	approvalStatus: string;
	comment: string;
	createdDate: string;
	id: number;
	requestType: string;
	requestedBy: string;
	treatedBy: string;
	treatedDate: string;
}

export interface Pnd {
	pndRequests: PndRequest[];
	totalItems: number;
	totalPages: number;
}

export interface SurveyOption {
	id: number;
	option: string;
	defaultOption: boolean;
}

export interface SurveyAnswerOption {
	id: number;
	percentage: number;
}

export interface Survey {
	id: number;
	message: string;
	surveyOptions: SurveyOption[];
}

export interface SurveyAnswer {
	id: number;
	options: SurveyAnswerOption[];
}

export enum MessageType {
	'ERROR',
	'SUCCESS',
	'WARNING',
	'COMPLETE',
	'BIOMETRIC',
	'RETRY',
	'REDIRECT'
}

export enum SignInForm {
	USERNAME = 'USERNAME',
	PASSWORD = 'PASSWORD'
}

export enum UserNameType {
	USERNAME = 'USERNAME',
	PHONENUMBER = 'PHONENUMBER'
}

export enum PasswordType {
	PASSWORD = 'PASSWORD',
	PASSCODE = 'PASSCODE'
}

export enum DialogMessageType {
	SUCCESS,
	FAILURE,
	SUSPENDED_OTP,
	INFO,
	WARNING,
	PENDING,
	IN_REVIEW,
	IN_PROGRESS
}

export enum DelegateType {
	hasLoggedInPreviously = 'hasLoggedInPreviously',
	getSavedUsername = 'getSavedUsername',
	getDeviceInformation = 'getDeviceInformation',
	setLoggedInUser = 'setLoggedInUser',
	hasSetupBiometric = 'hasSetupBiometric',
	getBiometricType = 'getBiometricType',
	authenticateWithBiometric = 'authenticateWithBiometric',
	deleteBiometricKey = 'deleteBiometricKey',
	flutterInAppWebViewPlatformReady = 'flutterInAppWebViewPlatformReady',
	saveOnboardingInfo = 'saveOnboardingInfo',
	getOnboardingInfo = 'getOnboardingInfo',
	getFirebaseToken = 'getFirebaseToken',
	shouldRegisterFirebaseToken = 'shouldRegisterFirebaseToken',
	setIsFirebaseTokenRegistered = 'setIsFirebaseTokenRegistered',
	isNotificationEnabled = 'isNotificationEnabled',
	requestNotificationSetup = 'requestNotificationSetup',
	launchDialer = 'launchDialer',
	getLoginCounter = 'getLoginCounter',
	updateLoginCounter = 'updateLoginCounter',
	getValue = 'getValue',
	saveValue = 'saveValue',
	selectFiles = 'selectFiles',
	getLoginParameters = 'getLoginParameters',
	launchMetaMapFlow = 'launchMetaMapFlow',
	listenForOtp = 'listenForOtp',
	launchEmailDialer = 'launchEmailHandler',
	launchFacebookApp = 'launchFacebook',
	launchWhatsApp = 'launchWhatsApp',
	launchInstagramApp = 'launchInstagram',
	launchTwitterApp = 'launchTwitter',
	launchSupportWebsite = 'launchSupportWebsite',
	enableTopSafeArea = 'enableTopSafeArea',
	getClipboardData = 'getClipboardData',
	getUserLocation = 'getUserLocation',
	downloadFile = 'downloadFile',
	saveFile = 'saveFile',
	shareFile = 'shareFile',
	requestCameraPermission = 'requestCameraPermission',
	isCameraEnabled = 'isCameraEnabled',
	launchCamera = 'launchCamera',
	adjustAddCallbackParameter = 'adjustAddCallbackParameter'
}

export enum ActionAfterModalClose {
	RESET_FORM = 'RESET_FORM ',
	// GO_TO_LOGIN = 'GO_TO_LOGIN',
	CLOSE = 'CLOSE',
	RELOAD = 'RELOAD',
	PROCEED = 'PROCEED',
	RETRY = 'RETRY',
}

export const POLICY_DOCUMENT_TYPE = {
    PRIVACY: 'privacy',
    COOKIES: 'cookies',
    TERMS_AND_CONDITION: 'terms_and_conditions',
} as const;

export type PolicyDocumentType = typeof POLICY_DOCUMENT_TYPE[keyof typeof POLICY_DOCUMENT_TYPE]

export interface PolicyResponse {
	content: string
}
